import { botPath, writeData } from '../../../utils/restApi';

// Ola 3: 'true' sends the chat actions to main_service: AI and follow-up switches,
// clear "suspicious" and read marks.
// The server does what the chat did in several calls: write, Redis cache sync and the activity event.
export const isChatActionsRest = (): boolean => process.env.NEXT_PUBLIC_REST_WRITE_CHAT_ACTIONS === 'true';

const sessionPath = (botId: string, sessionId: string, sub: string) => botPath(
  botId,
  `/sessions/${encodeURIComponent(sessionId)}${sub}`,
);

export type CreatedEvent = { id: string; created_at: string };

export async function setSessionAi(
  botId: string,
  sessionId: string,
  enabled: boolean,
): Promise<CreatedEvent | null> {
  const res = await writeData('put', sessionPath(botId, sessionId, '/ai'), { ai_enabled: enabled });
  return res.event ?? null;
}

export function setSessionFollowupDisabled(botId: string, sessionId: string, disabled: boolean) {
  return writeData('put', sessionPath(botId, sessionId, '/followup'), { disable_followup: disabled });
}

export async function clearSessionSuspicious(botId: string, sessionId: string): Promise<string[]> {
  return (await writeData('delete', sessionPath(botId, sessionId, '/contact/suspicious'))).tags;
}

// The server checks the bot's "mark as read for everyone" setting, as the chat did.
export function markSessionRead(botId: string, sessionId: string, lastMsgReadId: string): Promise<any> {
  return writeData('post', sessionPath(botId, sessionId, '/read'), { last_msg_read_id: lastMsgReadId });
}

export function setSessionManualUnread(botId: string, sessionId: string, manualUnread: boolean) {
  return writeData('put', sessionPath(botId, sessionId, '/unread'), { manual_unread: manualUnread });
}
